import { render, staticRenderFns } from "./ketersediaanChart.vue?vue&type=template&id=c412b066&"
import script from "./ketersediaanChart.vue?vue&type=script&lang=js&"
export * from "./ketersediaanChart.vue?vue&type=script&lang=js&"
import style0 from "./ketersediaanChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports